import gql from 'graphql-tag';

export const CREATE_PAYMENT_STRIPE = gql`
  mutation CreatePaymentStripe(
    $successUrl: String!
    $cancelUrl: String!
    $isPackage: Boolean
  ) {
    createPaymentStripe(
      successUrl: $successUrl
      cancelUrl: $cancelUrl
      isPackage: $isPackage
    )
  }
`;
